export default __webpack_public_path__ + "static/media/add_dependant_icon_white.607296a5.svg";